import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { DataGrid, Button } from "devextreme-react";
import { Column, RemoteOperations, Paging, Pager } from "devextreme-react/ui/data-grid";
import TableFilter from "../../../../Shared/tableFilter";
import { filterType } from "../../../../../helpers/filterHelper";
import { openCloseModalEliminarPrestacionSel, openCloseModalEditarPrestacionesSel, doGetPrestaciones, doGetFiltrosPrestacionesPes, doGetPrestacionById } from "./action";
import EmptyIcon from "../../../../Shared/EmptyIcon";
import ModalDelete from "./modalDelete";
import ModalEditar from "./modalEditar";
import validaciones from "../../../../../helpers/validaciones";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import ModalDesactivar from "./modalDesactivar";

class Prestaciones extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!this.props.filtrosPrestacionesSel) this.props.dispatch(doGetFiltrosPrestacionesPes());
    this.props.dispatch(doGetPrestaciones(null, true));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) {
      currentFilters.push({ column: "Description", value: { text, value: text }, type: filterType.search });
    }
    this.props.dispatch(doGetPrestaciones(currentFilters));
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarPrestacionesSel(true, {}, true));
  }

  handleEdit = (e) => {
    this.props.dispatch(doGetPrestacionById(e.data));
  }

  handleDelete = (e) => {
    this.props.dispatch(openCloseModalEliminarPrestacionSel(true, e.data));
  }

  render() {
    const { listaPrestacionesSelFiltradas, filtrosPrestacionesSel, tiposPrestacion } = this.props;
    return (
      <React.Fragment>
        <ModalDelete />
        <ModalEditar />
        <ModalDesactivar />
        {this.props.isLoading && <LoadingOverlay />}
        <TableFilter
          placeholder="Buscar prestaciones"
          onChange={this.handleFilterChange}
          filters={filtrosPrestacionesSel}
          show
          buttons={{
            filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
            document: { buttonName: "iconDocument", visible: false, buttonAction: null },
            download: { buttonName: "iconDownload", visible: false, buttonAction: null },
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar prestación",
            },
          }}
        />
        <DataGrid
          dataSource={listaPrestacionesSelFiltradas}
          noDataText=""
          className="custom-table"
          showBorders={false}
          showColumnLines={false}
          allowColumnResizing={false}
          columnAutoWidth={false}
          showRowLines={false}
          rowAlternationEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin prestaciones sel");
              noDataSpan.appendChild(element);
            }
          }}
        >
          <Column
            dataField="Description"
            allowSearch
            caption="Examen"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="group-Column-inline">
                  {row.data.Procesando ? (
                    <div className="material-icons" style={{ fontSize: "inherit" }}>schedule</div>
                  ) :
                    <EmptyIcon size={13} full={row.data.Status} />}
                  <div className="text space-text"> {row.data.Description}</div>
                </div>
                , element
              );
            }}
          />

          <Column
            dataField="ExamTypeId"
            alignment="center"
            dataType="LookUp"
            lookup={{
              dataSource: tiposPrestacion,
              displayExpr: "Name",
              valueExpr: "Id",
            }}
            caption="Tipo"
          />

          <Column
            dataField="Code"
            alignment="center"
            caption="Código SAP"
          />
          <Column
            caption=""
            alignment="right"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    onClick={() => this.handleEdit(row)}
                    className="slimButton"
                    type="success"
                    style={{ marginRight: 5 }}
                    text="Editar"
                  />
                  <Button
                    className="slimButton"
                    type="danger"
                    text="Eliminar"
                    disabled={!!row.data.Status}
                    onClick={() => this.handleDelete(row)}
                  />
                </div>
                , element);
            }}
          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={10}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
        </DataGrid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorPrestacionesSel.isLoading,
  listaPrestacionesSel: state.mantenedorPrestacionesSel.listaPrestacionesSel,
  listaPrestacionesSelFiltradas: state.mantenedorPrestacionesSel.listaPrestacionesSelFiltradas,
  filtrosPrestacionesSel: state.mantenedorPrestacionesSel.filtrosPrestacionesSel,
  tiposPrestacion: state.mantenedorPrestacionesSel.tiposPrestacion,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
export default connect(mapStateToProps, mapDispatchToProps)(Prestaciones);
